import { GlobalPageLoadExperience } from '@atlassian/ufo';

export function setupGlobalLoadExperienceTimings() {
  GlobalPageLoadExperience.timings = [
    {
      key: 'load-bridge',
      startMark: 'load-bridge-start',
      endMark: 'load-bridge-end',
    },
    {
      key: 'load-app',
      startMark: 'load-app-start',
      endMark: 'load-app-end',
    },
    {
      key: 'mount-bootstrap-skeleton',
      startMark: 'mount-bootstrap-skeleton-start',
      endMark: 'mount-bootstrap-skeleton-end',
    },
    {
      key: 'mount-skeleton',
      startMark: 'mount-skeleton-start',
      endMark: 'mount-skeleton-end',
    },
    {
      key: 'mount-app',
      startMark: 'mount-app-start',
      endMark: 'mount-app-end',
    },
    {
      key: 'intl-load',
      startMark: 'intl-load-start',
      endMark: 'intl-load-end',
    },
    {
      key: 'database-load',
      startMark: 'database-load-start',
      endMark: 'database-load-end',
    },
    {
      key: 'sdk-database-load',
      startMark: 'sdk-database-load-start',
      endMark: 'sdk-database-load-end',
    },

    // for databases overview page
    {
      key: 'space-databases-load',
      startMark: 'space-databases-load-start',
      endMark: 'space-databases-load-end',
    },
    {
      key: 'space-info-load',
      startMark: 'space-info-load-start',
      endMark: 'space-info-load-end',
    },
  ];
}
